import { axios } from '@Root/API'

export const remove = postgradId => {
	return axios.delete(`/delete/student-course-session/post-grade/${postgradId}`)
}
